// Module
var code = "<div class=\"intro__logo\"></div> <div class=\"intro__logotipo\"></div> <a class=\"sofia extra-bold c-red uppercase p12 underlined\" href=\"https://www.laminervetta.com/\" target=\"_blank\">minervetta place</a> <div class=\"intro__utils inter regular p3\"> <div class=\"language-selector\" data-color=\"blue\"></div> </div> ";
// Exports
export default code;